import { z } from 'zod';

export const tunDevSchema = z.string();

export const tunDevRequiredSchema = tunDevSchema.refine((val) => val !== '', {
  message: 'Choose a name for the TUN device',
});
